import { render, staticRenderFns } from "./postCompnent.vue?vue&type=template&id=fb82fe8c&scoped=true"
import script from "./postCompnent.vue?vue&type=script&lang=js"
export * from "./postCompnent.vue?vue&type=script&lang=js"
import style0 from "./postCompnent.vue?vue&type=style&index=0&id=fb82fe8c&prod&scoped=true&lang=css"
import style1 from "./postCompnent.vue?vue&type=style&index=1&id=fb82fe8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb82fe8c",
  null
  
)

export default component.exports